import { useEffect, useState } from 'react';

import HeaderCRM from './HeaderCRM';
import SidebarCRM from './SidebarCRM';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { fetchDataAndUpdateStore } from '../../redux/actions';
import {
  accountInputData,
  campaignInputData,
  contactInputData,
  dropdownPayload,
  dropdownPayloadCampaignContact,
  dropdownPayloadCampaignLead,
  invoiceInputData,
  leadInputData,
  opportunityInputData,
  salesOrderInputData,
  priceInputData,
  productInputData,
  ticketInputData,
  productReferenceLookup,
  auditLogInputData,
} from '../../shared/constants';
import MaintenancePage from './maintenance';
import { updateUserDetail } from '../../redux/reducer';

const PageLayoutCRM = (props) => {
  const pathname = useLocation().pathname;
  const dispatch = useDispatch();
  const user = useSelector((state) => state.data?.user?.user);
  const location = useLocation();

  const [visibileMenues, setVisibileMenues] = useState(null);
  let userPermissionsObj = { role: '', menues: {} };

  useEffect(() => {
    if (user) {
      let userDt = user;
      const roles = userDt?.roles || [];
      let role = 'User';
      if (roles?.some((role) => role?.roleName === 'System Manager')) {
        role = 'System Manager';
      } else if (roles?.some((role) => role?.roleName === 'Admin')) {
        role = 'Admin';
      }
      const userData = { ...userDt, role };
      // localStorage.setItem("userInformation", JSON.stringify(userData));
      dispatch(
        updateUserDetail({
          userInformation: userData,
        })
      );
      userPermissionsObj.role = userData?.role || '';

      // const uIPermissionData = userData.userUiPermissions;
      // const uniqueObjects = new Set(uIPermissionData.map(JSON.stringify));
      // const uIPermissionUniqueData = Array.from(uniqueObjects).map(JSON.parse);
      const uIPermissionUniqueData = userData.userUiPermissions;

      let menues = { ...visibileMenues };
      // The API now returns a flat list of granted permissions only (no canView/canEdit
      // flags per entry) - an entry's presence in this list means it is granted.
      function buildTree(uIPermissionUniqueData) {
        const tree = {};
        uIPermissionUniqueData
          .filter((obj) => obj.permissionTypeName === 'Menu')
          .forEach((menu) => {
            const children = buildScreenTree(uIPermissionUniqueData, menu.permissionId);
            if (!menu.permissionParentId) {
              // Top-level menu (permissionParentId is null, undefined, or '')
              if (Object.keys(children).length > 0) {
                tree[menu.permissionValue.toLowerCase()] = children;
              }
              menues = {
                ...menues,
                [menu.permissionValue.toLowerCase()]: true,
              };
            } else {
              // Nested menu: find parent in tree and add as child
              const parentKey = uIPermissionUniqueData
                .find(
                  (parent) =>
                    parent.permissionId === menu.permissionParentId &&
                    parent.permissionTypeName === 'Menu'
                )
                ?.permissionValue?.toLowerCase();
              if (parentKey) {
                if (!tree[parentKey]) tree[parentKey] = {};
                tree[parentKey][menu.permissionValue.toLowerCase()] = children;
                menues = {
                  ...menues,
                  [menu.permissionValue.toLowerCase()]: true,
                };
              }
            }
          });
        return tree;
      }

      function buildScreenTree(uIPermissionUniqueData, parentId) {
        const screens = {};
        uIPermissionUniqueData
          .filter(
            (obj) => obj.permissionParentId === parentId && obj.permissionTypeName === 'Screen'
          )
          .forEach((screen) => {
            const children = buildFieldList(uIPermissionUniqueData, screen.permissionId);
            screens[screen.permissionValue.toLowerCase()] = {
              ...children,
              canEdit: true,
              canView: true,
            };
          });
        return screens;
      }

      function buildFieldList(uIPermissionUniqueData, parentId) {
        const fields = {};
        uIPermissionUniqueData
          .filter(
            (obj) => obj.permissionParentId === parentId && obj.permissionTypeName === 'Field'
          )
          .forEach((field) => {
            fields[field.permissionValue] = {
              canEdit: true,
              canView: true,
            };
          });
        return fields;
      }
      // Start building the tree from the root level
      const formattedResult = buildTree(uIPermissionUniqueData);
      setVisibileMenues(menues);
      userPermissionsObj.menues = menues;
      props.userPermissions(userPermissionsObj, formattedResult);
      localStorage.setItem('userUIControlPermission', JSON.stringify(formattedResult));
      dispatch(
        updateUserDetail({
          userUIControlPermission: formattedResult,
        })
      );
    }
  }, [user]);

  const genericMasterFiltereddata = {
    type: [
      'RevenueType',
      'LeadSource',
      'Industry',
      'AccountType',
      'TimeZone',
      'Salutation',
      'ContactPersonRole',
      'Stage',
      'CampaignSource',
      'MemberStatusCrm',
      'ForecastCategory',
      'ProjectTypeCrm',
      'TicketPriorityCrm',
      'StatusCrm',
      'CampaignType',
      'CampaignStatus',
      'QuoteStage',
      'Carrier',
      'SaleOrderStatus',
      'Currency',
      'PriceModel',
      'UsageUnit',
      'Tax',
      'InvoiceStatus',
      'UOM',
      'SequenceType',
      'TriggerOutreach',
      'LOB'
    ],
  };
  const searchParams = new URLSearchParams(location.search);
  const pageNo = searchParams?.get('pageNo');

  const checkSearchParams = (payload) => {
    if (pageNo) {
      return { ...payload, pageNumber: pageNo };
    } else {
      return payload;
    }
  };

  const pageListMapping = {
    // massEmailLeadSent: {
    //   key: "massEmailLeadSent",
    //   inputData: {
    //     ...contactInputData,
    //     module: "Lead",
    //     columnName: "createdDateTime",
    //     status: "",
    //   },
    // },
    // massEmailContactSent: {
    //   key: "massEmailContactSent",
    //   inputData: {
    //     ...contactInputData,
    //     module: "Contact",
    //     columnName: "createdDateTime",
    //     status: "",
    //   },
    // },
    // leadTags: { key: "tagsByModule", inputData: "Lead", storeKey: "leads" },
    // contactTags: {
    //   key: "tagsByModule",
    //   inputData: "Contact",
    //   storeKey: "contactList",
    // },
    // accountTags: {
    //   key: "tagsByModule",
    //   inputData: "Account",
    //   storeKey: "accountList",
    // },
    // opportunityTags: {
    //   key: "tagsByModule",
    //   inputData: "Opportunity",
    //   storeKey: "opportunityList",
    // },
    // campaignTags: {
    //   key: "tagsByModule",
    //   inputData: "Campaign",
    //   storeKey: "campaignList",
    // },
    // 'owners' is not fetched separately — it's the same GetUsersAsync data as 'userList',
    // mirrored into state.data.owners by the reducer when the 'userList' fetch resolves.
    userList: { key: 'userList' },
    geographyNodes: { key: 'geographyNodes' },
    orgUnitNodes: { key: 'orgUnitNodes' },
    auditLogs: {
      key: 'auditLogs',
      inputData: auditLogInputData,
    },
    genericMasterFilteredData: {
      key: 'genericMasterFilteredList',
      inputData: genericMasterFiltereddata,
    },
    userActivity: { key: 'userActivity', inputData: { pageSize: 500, pageNumber: 1, userId: 0 } },
    // leads: { key: "leads", inputData: checkSearchParams(leadInputData) },

    // contactList: {
    //   key: "contactList",
    //   inputData: checkSearchParams(contactInputData),
    // },
    // accountList: {
    //   key: "accountList",
    //   inputData: checkSearchParams(accountInputData),
    // },
    // opportunityList: {
    //   key: "opportunityList",
    //   inputData: checkSearchParams(opportunityInputData),
    // },
    productReferenceLookup: {
      key: 'productReferenceLookup',
      inputData: productReferenceLookup,
    },
    // campaignList: {
    //   key: "campaignList",
    //   inputData: checkSearchParams(campaignInputData),
    // },
    // ticketList: {
    //   key: "ticketList",
    //   inputData: checkSearchParams(ticketInputData),
    // },
    // qouteList: {
    //   key: "quoteList",
    //   inputData: checkSearchParams(contactInputData),
    // },
    // productList: {
    //   key: "productList",
    //   inputData: checkSearchParams(productInputData),
    // },
    // priceSheetList: {
    //   key: "priceSheetList",
    //   inputData: checkSearchParams(priceInputData),
    // },
    // leadDropdown: { key: "leadDropdown", inputData: dropdownPayload },
    // contactDropdown: { key: "contactDropdown", inputData: dropdownPayload },
    accountDropdown: { key: 'accountDropdown', inputData: dropdownPayload },
    // opportunityDropdown: {
    //   key: "opportunityDropdown",
    //   inputData: dropdownPayload,
    // },

    // campaignDropdownLead: {
    //   key: "campaignDropdownLead",
    //   inputData: dropdownPayloadCampaignLead,
    // },
    // campaignDropdownContact: {
    //   key: "campaignDropdownContact",
    //   inputData: dropdownPayloadCampaignContact,
    // },
    productDropdown: { key: 'productDropdown', inputData: dropdownPayload },

    template: { key: 'template' },
    // salesOrder: { key: "salesOrder", inputData: salesOrderInputData },
    // invoice: { key: "invoice", inputData: invoiceInputData },
  };
  // const shouldFetchTemplate = pathname.startsWith("/lead")  || pathname.startsWith("/campaign") || pathname.startsWith("/contact");

  // useFetchIfNeeded(
  //   getAllTemplate,
  //   fetchDataAndUpdateStore,
  //   shouldFetchTemplate ? { key: "template" } : null
  // );
  useEffect(() => {
    // Trigger API calls for each list
    Object.values(pageListMapping).forEach((list) => {
      dispatch(fetchDataAndUpdateStore(list));
    });
  }, [dispatch]);

  useEffect(() => {
    document.title = 'CRM';
  }, []);

  const hideSidebarRoutes = [
    '/settings/templateGallery/newTemplate',
    '/settings/templateGallery/updateTemplate',
    '/quoteAI/sidebarQuoteAi',
    '/quoteAI/rightHeaderPage',
    '/quoteAI/fullWorkBookPage',
    '/quoteAI/alfredAlertPage',
    '/quoteAI/insuredInformationPage',
    '/quoteAI/contactInformationPage',
    '/quoteAI/deductiblePage',
    '/quoteAI/includedExcludedOfficerPage',
    '/quoteAI/locationClassCodePage',
    '/quoteAI/lossDetailPage',
    '/quoteAI/policyTermPage',
    '/quoteAI/preQualifierQuestionPage',
    '/quoteAI/quotedPremiumPage',
    '/quoteAI/ratingInformationPage',
    '/quoteAI/underwritingInformationPage',
    '/quoteAI/additionalFormPage',
    '/quoteAI/locationPage',
    '/quoteAI/headerQuoteAiView',
    '/quoteAI/sidebarQuoteAiViewPage',
    '/quoteAI/insuredInformationViewPage',
    '/quoteAI/contactInformationViewPage',
    '/crm/quoteAI/policyTermViewPage',
  ];

  const shouldHideSidebar = hideSidebarRoutes.includes(location.pathname);

  const isDesktop = () => window.innerWidth >= 600;
  const [toggleMenu, SetToggleMenu] = useState(() => isDesktop());
  useEffect(() => {
    const handleResize = () => {
      SetToggleMenu(isDesktop());
    };

    // Set correct initial state on mount
    handleResize();

    // Listen for window resize
    window.addEventListener('resize', handleResize);

    // Cleanup
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleToggleMenu = () => {
    SetToggleMenu((prev) => !prev);
  };

  const handleHideMenu = () => {
    SetToggleMenu(false);
  };

  return (
    <>
      {location.pathname.includes('maintenance') ? (
        <MaintenancePage />
      ) : (
        <section>
          <div
            className={`crm_dashboard flex_clmn ${!shouldHideSidebar ? 'gos-app' : ''}`}
            id="CRM_pageSection"
          >
            {shouldHideSidebar ? (
              // Full-bleed routes (email builder, quoteAI wizard): no sidebar/header,
              // so skip the empty gos-shell-main/gos-scroll-body wrappers entirely —
              // render the content container directly under #CRM_pageSection.
              <div className="dashboard_container mobContainer" style={{ marginLeft: '0px' }}>
                {window.innerWidth <= 767 ? (
                  <div onClick={handleHideMenu} style={{ width: '100%' }}>
                    {props.children}
                  </div>
                ) : (
                  <> {props.children}</>
                )}
              </div>
            ) : (
              <>
                <SidebarCRM
                  visibileMenues={visibileMenues}
                  toggleMenu={toggleMenu}
                  handleToggleMenu={handleToggleMenu}
                />
                <div className="gos-shell-main">
                  <HeaderCRM handleToggleMenu={handleToggleMenu} toggleMenu={toggleMenu} />
                  <div className="gos-scroll-body">
                    <div
                      className={toggleMenu ? 'dashboard_container ' : 'dashboard_container mobContainer'}
                      style={{ marginLeft: '0px' }}
                    >
                      {window.innerWidth <= 767 ? (
                        <div onClick={handleHideMenu} style={{ width: '100%' }}>
                          {props.children}
                        </div>
                      ) : (
                        <> {props.children}</>
                      )}
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </section>
      )}
    </>
  );
};

export default PageLayoutCRM;
